import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { currentDate } from '../../../core/helper';
import { DEFAULT_INSTITUTIONAL_WEBSITE_URL, DEFAULT_PRIVACY_POLICY_URL } from '../../../core/constants';

const RESTORE_LOGIN_STEP_KEY = 'restoreLoginStep';

export const HomeAuthFooter = ({ className = 'mt-auto', loginStep }) => {
    const systemCheck = useSelector(state => state?.systemCheck?.data?.data);
    const privacyPolicyUrl = systemCheck?.privacy_policy_url || DEFAULT_PRIVACY_POLICY_URL;
    const institutionalWebsiteUrl = systemCheck?.institutional_website_url || DEFAULT_INSTITUTIONAL_WEBSITE_URL;

    const handleContactUsClick = () => {
        if (loginStep) {
            sessionStorage.setItem(RESTORE_LOGIN_STEP_KEY, String(loginStep));
        }
    };

    return (
        <div className={`text-center mx-auto w-100 ${className}`}>
            <div className='border-top border-bottom mb-3 d-flex justify-content-around py-1 w-100'>
                <Link
                    to="/contact-us"
                    onClick={handleContactUsClick}
                    className="text-muted welcome-link p-2 small"
                >
                    Contact us
                </Link>
                <a href={institutionalWebsiteUrl} target="blank" className="text-muted welcome-link p-2 small">About True Talent Labs</a>
                <a href={privacyPolicyUrl} target="blank" className="text-muted welcome-link p-2 small">Privacy Policy</a>
            </div>
            <p className='text-muted small mb-0'><i>Copyright True Leadership Solutions LLC. {currentDate()}. All rights reserved.</i></p>
        </div>
    )
}
